import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogActions, Button, Typography, Box, Grid, Avatar, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BeenhereIcon from '@mui/icons-material/Beenhere';
import CloseIcon from '@mui/icons-material/Close';
import StarIcon from '@mui/icons-material/Star';

const THEME_MAP = {
  basic: {
    gradient: 'linear-gradient(135deg, #E6F7FF 0%, #F5FAFF 100%)',
    accent: '#0B91D6',
    iconBg: '#E6F7FF'
  },
  advanced: {
    gradient: 'linear-gradient(135deg, #FFF8ED 0%, #FFF6F2 100%)',
    accent: '#FF711A',
    iconBg: '#FFF3E6'
  },
  pro: {
    gradient: 'linear-gradient(135deg, #F6F5FF 0%, #FBF8FF 100%)',
    accent: '#8B5CF6',
    iconBg: '#F2EEFF'
  }
};

const CongratsModal = ({ open, onClose, plan = 'basic', features = [], planLabel = '' }) => {
  const navigate = useNavigate();
  const p = String(plan || 'basic').toLowerCase();
  const theme = THEME_MAP[p] || THEME_MAP.basic;
  const displayLabel = planLabel || (plan && String(plan).charAt(0).toUpperCase() + String(plan).slice(1)) || 'Basic';

  const handleAction = (action) => {
    try {
      // Clear the force_pricing flag after successful payment
      try { localStorage.removeItem('force_pricing'); } catch (_) { }

      // Navigate to client-onboarding for new users after payment
      navigate('/client-onboarding');

      if (onClose) onClose(action);
    } catch (e) {
      // ignore
    }
  };

  return (
    <Dialog open={!!open} onClose={() => handleAction('dashboard')} fullWidth maxWidth="sm">
      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ background: theme.gradient, p: 3, borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Avatar sx={{ bgcolor: theme.iconBg, width: 64, height: 64 }}>
                <CheckCircleIcon sx={{ color: theme.accent, fontSize: 38 }} />
              </Avatar>
            </Grid>
            <Grid item xs>
              <Typography variant="h6" sx={{ fontWeight: 800, color: '#0B1D4A' }}>
                Congratulations!
              </Typography>
              <Typography variant="body2" sx={{ color: '#374151', mt: 0.5 }}>
                Your {displayLabel} plan is now active.
              </Typography>
            </Grid>
            <Grid item>
              <Box sx={{ textAlign: 'right' }}>
                <StarIcon sx={{ color: theme.accent, fontSize: 28 }} />
                <Typography variant="caption" sx={{ display: 'block', fontWeight: 700 }}>{displayLabel}</Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ p: 3 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>What's included</Typography>
          {Array.isArray(features) && features.length ? (
            <List dense>
              {features.map((f, i) => (
                <ListItem key={i} disableGutters>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <BeenhereIcon sx={{ color: theme.accent }} />
                  </ListItemIcon>
                  <ListItemText primary={<Typography sx={{ fontWeight: 600 }}>{f}</Typography>} />
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography variant="body2">No specific features to list.</Typography>
          )}
        </Box>

        <Box sx={{ display: 'flex', gap: 2, p: 3, pt: 0, justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleAction('onboarding')}
            sx={{ textTransform: 'none' }}
          >
            Continue Setup
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CongratsModal;
